<template>
    <div class="signup-page">

      <section class="logo">
        <router-link class="nav-homelogo" to="/">
          <img src="@/assets/images/Logo_Awesome_SVG.svg" alt="" class="nav-logo">
        </router-link>

      </section>

      <SignUpForm/>
    </div>
</template>

<script>

import SignUpForm from '@/components/SignUpForm.vue'

export default {
  name: 'SignUp',
  components: {
    SignUpForm
  }
}
</script>
